module.exports = __webpack_public_path__ + "montserrat-light-webfont.a11330db59d1e0d7b093.eot";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/~/@okta/okta-signin-widget/dist/font/montserrat-light-webfont.eot
// module id = ../../../../@okta/okta-signin-widget/dist/font/montserrat-light-webfont.eot
// module chunks = 11